import { getLocale } from "../runtime";

const sv_couponcodelabel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ange rabattkod`
};

const couponcodelabel = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_couponcodelabel(inputs)
	return "couponCodeLabel";
};

export { couponcodelabel as "couponCodeLabel" };